import { TextFieldProps, TextField, makeStyles } from "@material-ui/core";
import { ITheme } from "../constants/theme";

type IProps = TextFieldProps;

export const TextFieldInput = (props: IProps) => {
  const classes = useStyles();
  return (
    <TextField
      FormHelperTextProps={{
        classes: {
          root: classes.helperText,
          focused: classes.helperTextFocused,
        },
      }}
      InputProps={{
        classes: {
          root: classes.cssOutlinedInput,
          focused: classes.cssFocused,
          notchedOutline: classes.notchedOutline,
        },
      }}
      {...props}
      margin="normal"
      variant="outlined"
      fullWidth
    />
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  cssFocused: {},
  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  helperText: {
    paddingTop: 4,
    fontWeight: 400,
    letterSpacing: 0.4,
  },
  helperTextFocused: {
    color: theme.palette.primary.main,
  },
}));
